import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const statusTrackCta = () => {
  return (
    <div className="mx-auto flex h-[280px] w-[280px] items-center justify-center rounded-full bg-white font-montserrat drop-shadow-lg md:h-[400px] md:w-[400px] lg:h-[590px] lg:w-[590px]">
      <Link
        href="/resume-writing/resume-status"
        className="fade-in-top-hero absolute -left-8 top-10 rounded-xl border-2 border-gray-300 bg-white px-4 py-3 text-[10px] font-medium text-[#151515] md:-left-3 md:px-6 md:text-sm lg:-left-1 lg:px-8 lg:text-base"
      >
        Contact Us
      </Link>
      <Link
        href="/resume-writing/resume-status"
        className="flex h-[200px] w-[200px] cursor-pointer items-center justify-center rounded-full bg-[#F8F8FF] drop-shadow-lg hover:bg-gray-200 md:h-[250px] md:w-[250px] lg:h-[350px] lg:w-[350px]"
      >
        <div className="flex flex-col items-center text-center">
          <span className="text-sm font-semibold text-[#151515] md:text-base lg:text-lg">
            Track Status
          </span>
          <span className="mt-2 text-[10px] text-[#888686] hover:font-semibold md:text-xs lg:text-sm">
            Click to view progress
          </span>
          <ArrowRightIcon className="mt-4 h-4 w-4 text-xl text-[#151515] md:h-6 md:w-6" />
        </div>
      </Link>
      <div className="fade-in-diagonal-right absolute bottom-[-7%] left-[70%] w-[120px] rounded-xl border-2 border-gray-300 bg-white p-3 text-[9px] text-[#888686] md:bottom-[10%] md:left-[85%] md:w-[200px] md:text-xs lg:bottom-[20%] lg:w-[350px] lg:text-sm">
        Check your Resume Revamp Status. You can view the progress of your
        resume writing and contact us for any queries.
      </div>

      {/* Paper Images */}
      <PaperImage
        src="1"
        alt="Paper 1"
        style="md:w-[87px] w-[67px] h-[75px] md:h-[94px] absolute md:top-7 top-2 -right-10 md:-right-12 lg:-right-1"
      />
      <PaperImage
        src="2"
        alt="Paper 1"
        style="w-[28px] h-[34px] md:w-[38px] md:h-[50px] absolute md:top-[43%] lg:top-1/2 -right-10 md:-right-32"
      />
      <PaperImage
        src="3"
        alt="Paper 1"
        style="md:w-[38px] md:h-[50px] w-[28px] h-[34px] -left-1 absolute bottom-4 md:bottom-14 md:-left-8 lg:-left-0"
      />
    </div>
  );
};

export default statusTrackCta;

const PaperImage = ({
  src,
  alt,
  style,
}: {
  src: string;
  alt: string;
  style?: string;
}) => {
  return (
    <div className={`${style}`}>
      <Image
        src={`/assets/resume-writing/paperImages/paper${src}.png`}
        alt={alt}
        fill
      />
    </div>
  );
};
